exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item-label[data-v-53342008] {\n  margin-left: 20px;\n  font-weight: bold;\n}\n", ""]);

// exports
